import React, { FunctionComponent } from 'react';
import '../../../styles/news-forge.styles.scss';
import { DATA_QA } from '../../../helpers/data-qa';

export type ButtonProps = {
	text: string;
	title?: string;
	maxWidth?: string;
	onClickAction: (event: React.MouseEvent) => void;
	disabled: boolean;
};

export const ReGenerateTextButton: FunctionComponent<ButtonProps> = ({ text, title, maxWidth, onClickAction, disabled }) => {
	return (
		<div data-qa={DATA_QA.NEWS_FORGE_REGENERATE_TEXT_BUTTON} className='re-generate-text-button-container'>
			<div
				className={`re-generate-text-button ${disabled ? 'disabled' : ''}`}
				title={title}
				style={{ maxWidth: maxWidth || 'auto' }}
				onClick={(e) => {
					if (!disabled) {
						onClickAction(e);
					}
				}}
			>
				<span className='redo-icon' />
				<span className='button-label'>{text}</span>
			</div>
		</div>
	);
};

export default ReGenerateTextButton;
